let breedsData = [];
let servicesData = [];
let addonsData = [];
const selectedItems = new Map();

function getProductType(item) {
  return (item["PRODUCT"] || item["PRODUCT "] || '').trim().toLowerCase();
}

function fetchAddons() {
  return fetch(window.addonsJsonUrl).then(res => res.json()).then(data => addonsData = data);
}

function fetchBreeds(petType) {
  const url = petType === 'cat' ? window.catBreedsJsonUrl : window.dogBreedsJsonUrl;
  return fetch(url).then(res => res.json()).then(data => breedsData = data.breeds || data);
}

function fetchServices() {
  return fetch(window.servicesJsonUrl).then(res => res.json()).then(data => servicesData = data.services || data);
}

function formatDuration(duration) {
  if (!duration) return 0;
  duration = duration.toLowerCase();
  let totalMins = 0;
  const matches = duration.match(/(\d+)\s*(hr|hour|hours|min|minute|minutes)/g);
  if (matches) {
    matches.forEach(part => {
      const num = parseInt(part);
      if (part.includes("hr") || part.includes("hour")) totalMins += num * 60;
      else if (part.includes("min")) totalMins += num;
    });
  } else {
    const numMatch = duration.match(/\d+/);
    totalMins = numMatch ? parseInt(numMatch[0]) : 0;
  }
  return totalMins;
}

function updateSelectionSummary() {
  let totalPrice = 0;
  let totalMinutes = 0;
  selectedItems.forEach(item => {
    totalPrice += item.price || 0;
    totalMinutes += item.duration || 0;
  });
  document.getElementById('total-price').textContent = totalPrice.toFixed(0);
  document.getElementById('total-duration').textContent = `${totalMinutes} min`;
  document.getElementById('selection-summary').style.display = (totalPrice > 0 || totalMinutes > 0) ? 'block' : 'none';
}

function getSelectedSpecies() {
  const petTypeRadios = document.querySelectorAll("input[name='petType']");
  if (!petTypeRadios || petTypeRadios.length === 0) return '';
  const checkedRadio = Array.from(petTypeRadios).find(r => r.checked);
  return checkedRadio ? checkedRadio.value : '';
}

function findBreedRecord(breedName) {
  const lowerInput = breedName.trim().toLowerCase();
  return breedsData.find(b => {
    const name = (b.Breed || b.name || '').trim().toLowerCase();
    return name === lowerInput;
  });
}

function createPlanCard(services, cardType) {
  if (!services.length) return '';
  
  const service = services[0];
  const id = service["SERVICE_ITEM_NAME"] || service["SERVICE ITEM NAME"] || service["SERVICE"];
  const price = parseFloat(service.MRP) || parseFloat(service.PRICE) || 0;
  const duration = formatDuration(service.DURATION || "");
  const durationLabel = service.DURATION || "";
  const productType = getProductType(service);
  
  let title, content;
  switch(productType) {
    case 'washing':
      title = 'Essential Care';
      content = `
        <div class="plan-content-wrapper">
          <h3 style="text-align : center; ">${title}</h3>
          <div class="plan-duration">${durationLabel}</div>
          <div class="plan-includes-header">Includes:</div>
          <ul class="plan-features">
            <li>3 Step Therapy Bath
              <ul style="list-style: none; padding: 0; margin: 4px 0 0 0;">
                <li class="sub-item">Deep Cleanse</li>
                <li class="sub-item" >Function Shampoo</li>
                <li class="sub-item" >Fixation Mask</li>
              </ul>
            </li>
            <li class="plus-item">+</li>
            <li>Hygiene Care
              <ul style="list-style: none; padding: 0; margin: 4px 0 0 0;">
                <li class="sub-item">Nail Cutting</li>
                <li class="sub-item">Ear Cleaning</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="plan-price-wrapper">
          <div class="plan-mrp"><span class="currency">₹</span>${price}</div>
        </div>
      `;
      break;
    case 'washing + hair cutting':
      title = 'Essential Care <span style="font-size: 20px; color: #ffb400;">+</span>';
      content = `
        <div class="plan-content-wrapper">
          <h3 style="text-align : center; ">${title}</h3>
          <div class="plan-duration">${durationLabel}</div>
          <div class="plan-includes-header">Includes:</div>
          <ul class="plan-features">
            <li>Essential Care</li>
            <li class="plus-item">+</li>
            <li>Hair Styling</li>
          </ul>
        </div>
        <div class="plan-price-wrapper">
          <div class="plan-mrp"><span class="currency">₹</span>${price}</div>
        </div>
      `;
      break;
    case 'washing + zero trim':
      title = 'Regular Care';
      content = `
        <div class="plan-content-wrapper">
          <h3 style="text-align : center; ">${title}</h3>
          <div class="plan-duration">${durationLabel}</div>
          <div class="plan-includes-header">Includes:</div>
          <ul class="plan-features">
            <li>Essential Care</li>
            <li class="plus-item">+</li>
            <li>Zero Hair Trim</li>
            <li class="plus-item">+</li>
            <li>Hygiene Care
              <ul style="list-style: none; padding: 0; margin: 4px 0 0 0;">
                <li class="sub-item">Nail Cutting</li>
                <li class="sub-item">Ear Cleaning</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="plan-price-wrapper">
          <div class="plan-mrp"><span class="currency">₹</span>${price}</div>
        </div>
      `;
      break;
    default:
      title = id;
      content = `
        <div class="plan-content-wrapper">
          <h3 style="text-align : center; ">${title}</h3>
          <div class="plan-duration">${durationLabel}</div>
          <ul class="plan-features">
            <li>${durationLabel}</li>
            <li>Price: ₹${price}</li>
          </ul>
        </div>
        <div class="plan-price-wrapper">
          <div class="plan-mrp"><span class="currency">₹</span>${price}</div>
        </div>
      `;
  }
  
  return content;
}


function createExtraCard(services, title) {
  if (!services.length) return '';
  
  const service = services[0];
  const id = service["SERVICE_ITEM_NAME"] || service["SERVICE ITEM NAME"] || service["Add-on Name"] || service["SERVICE"];
  const price = parseFloat(service.MRP) || parseFloat(service.PRICE) || 0;
  const durationLabel = service.DURATION || "";
  
  return `
    <div class="extra-content">
      <h3>${title}</h3>
      <div class="extra-price">₹ ${price}</div>
      <div class="extra-duration">${durationLabel}</div>
    </div>
  `;
}

function attachCardClickHandlers() {
  const exclusiveTypes = new Set([
    'washing',
    'washing + hair cutting',
    'washing + zero trim',
    'healing bath'
  ]);

  // Handle plan cards
  document.querySelectorAll('.plan-product-card').forEach(card => {
    card.onclick = () => {
      const cardData = card.dataset;
      if (!cardData.id) return;
      
      const id = cardData.id;
      const price = parseFloat(cardData.price);
      const duration = parseInt(cardData.duration);
      const productType = cardData.productType;

      if (selectedItems.has(id)) {
        selectedItems.delete(id);
        card.classList.remove('selected');
      } else {
        // Remove other exclusive selections
        if (exclusiveTypes.has(productType)) {
          for (let [key, value] of selectedItems) {
            if (value.productTypeIsExclusive) {
              selectedItems.delete(key);
              const oldCard = document.querySelector(`[data-id="${key}"]`);
              if (oldCard) oldCard.classList.remove('selected');
            }
          }
        }
        selectedItems.set(id, { price, duration, productTypeIsExclusive: exclusiveTypes.has(productType) });
        card.classList.add('selected');
      }
      updateSelectionSummary();
    };
  });

  // Handle extra cards
  document.querySelectorAll('.extra-product-card').forEach(card => {
    card.onclick = () => {
      const cardData = card.dataset;
      if (!cardData.id) return;
      
      const id = cardData.id;
      const price = parseFloat(cardData.price);
      const duration = parseInt(cardData.duration);
      const productType = cardData.productType;

      if (selectedItems.has(id)) {
        selectedItems.delete(id);
        card.classList.remove('selected');
      } else {
        if (exclusiveTypes.has(productType)) {
          for (let [key, value] of selectedItems) {
            if (value.productTypeIsExclusive) {
              selectedItems.delete(key);
              const oldCard = document.querySelector(`[data-id="${key}"]`);
              if (oldCard) oldCard.classList.remove('selected');
            }
          }
        }
        selectedItems.set(id, { price, duration, productTypeIsExclusive: exclusiveTypes.has(productType) });
        card.classList.add('selected');
      }
      updateSelectionSummary();
    };
  });

  // Handle addon checkboxes
  document.querySelectorAll('.addon-checkbox').forEach(checkbox => {
    checkbox.onchange = () => {
      const row = checkbox.closest('tr');
      const id = checkbox.dataset.id;
      const price = parseFloat(checkbox.dataset.price);
      const duration = parseInt(checkbox.dataset.duration);

      if (checkbox.checked) {
        selectedItems.set(id, { price, duration, productTypeIsExclusive: false });
        row.classList.add('selected');
      } else {
        selectedItems.delete(id);
        row.classList.remove('selected');
      }
      updateSelectionSummary();
    };
  });
}

function updateProductCards(containerId, label, services, isExtra = false) {
  const container = document.getElementById(containerId);
  if (!container) return;
  
  if (!services.length) {
    container.innerHTML = `<h3>${label}</h3><p style="text-align:center; color: #666;">No ${label.toLowerCase()} found for this selection.</p>`;
    container.style.display = 'block';
    return;
  }

  const service = services[0];
  const id = service["SERVICE_ITEM_NAME"] || service["SERVICE ITEM NAME"] || service["Add-on Name"] || service["SERVICE"];
  const price = parseFloat(service.MRP) || parseFloat(service.PRICE) || 0;
  const duration = formatDuration(service.DURATION || "");
  const productType = getProductType(service);

  // Set data attributes for click handling
  container.dataset.id = id;
  container.dataset.price = price;
  container.dataset.duration = duration;
  container.dataset.productType = productType;

  if (isExtra) {
    container.innerHTML = createExtraCard(services, label);
  } else {
    container.innerHTML = createPlanCard(services, productType);
  }

  // Show the container
  container.style.display = 'block';

  // Restore selection state
  if (selectedItems.has(id)) {
    container.classList.add('selected');
  } else {
    container.classList.remove('selected');
  }
}

function updateAddonsTable(services) {
  const container = document.getElementById('addons');
  if (!container) return;
  
  if (!services.length) {
    container.innerHTML = `<h3>Choose Add-ons</h3><p style="text-align:center; color: #666;">No add-ons found for this selection.</p>`;
    container.style.display = 'block';
    return;
  }

  const rows = services.map(service => {
    const id = service["SERVICE_ITEM_NAME"] || service["SERVICE ITEM NAME"] || service["Add-on Name"] || service["SERVICE"];
    const durationLabel = service.DURATION || "";
    const duration = formatDuration(durationLabel);
    const price = parseFloat(service.MRP) || parseFloat(service.PRICE) || 0;
    const isChecked = selectedItems.has(id);
    
    return `
      <tr class="addon-row ${isChecked ? 'selected' : ''}" data-id="${id}">
        <td>
          <input type="checkbox" class="addon-checkbox" ${isChecked ? 'checked' : ''} 
                 data-id="${id}" data-price="${price}" data-duration="${duration}">
        </td>
        <td>${id}</td>
        <td>${durationLabel}</td>
        <td>₹${price.toFixed(0)}</td>
      </tr>
    `;
  }).join('');

  container.innerHTML = `
    <h3>Choose Add-ons</h3>
    <table>
      <thead>
        <tr>
          <th>Select</th>
          <th>Add-on Name</th>
          <th>Duration</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  `;
  
  container.style.display = 'block';
}

function filterTables(breedRec, species, age) {
  const normSpecies = species.charAt(0).toUpperCase() + species.slice(1);
  const selectedSize = breedRec ? (breedRec.Size || '') : '';
  const selectedCoat = breedRec ? (breedRec.Coat || '') : '';

  // Show the section headers and card containers
  const sectionHeaders = document.querySelectorAll('.section-header');
  sectionHeaders.forEach(header => {
    header.style.display = 'block';
  });
  
  const plansContainer = document.querySelector('.plans-horizontal-cards');
  const extrasContainer = document.querySelector('.extras-horizontal-cards');
  
  if (plansContainer) plansContainer.style.display = 'grid';
  if (extrasContainer) extrasContainer.style.display = 'grid';

  // Filter main plans
  [
    { key: "washing", id: "washing", label: "Essential Care" },
    { key: "washing + hair cutting", id: "washing-hair-cutting", label: "Essential Care Plus" },
    { key: "washing + zero trim", id: "washing-zero-trim", label: "Regular Care" }
  ].forEach(({key, id, label}) => {
    const group = servicesData.filter(service => {
      if (getProductType(service) !== key) return false;
      const sSpecies = (service.SPECIES || '').trim().toLowerCase();
      const sSize = (service.SIZE || '').trim();
      const sCoat = (service.COAT || '').trim();
      const sAge = (service.AGE || '').trim();
      const coatMatch = !selectedCoat || !sCoat || sCoat === selectedCoat;
      const ageMatch = !age || !sAge || sAge === age;
      return sSpecies === normSpecies.toLowerCase() &&
             (!selectedSize || sSize === selectedSize) &&
             coatMatch &&
             ageMatch;
    });
    updateProductCards(id, label, group, false);
  });

  // Filter healing bath from services
  const healingBathGroup = servicesData.filter(service => {
    if (getProductType(service) !== 'healing bath') return false;
    const sSpecies = (service.SPECIES || '').trim().toLowerCase();
    const sSize = (service.SIZE || '').trim();
    const sCoat = (service.COAT || '').trim();
    const sAge = (service.AGE || '').trim();
    if (sSpecies !== normSpecies.toLowerCase()) return false;
    if (selectedSize && sSize && sSize !== selectedSize) return false;
    if (selectedCoat && sCoat && sCoat !== selectedCoat) return false;
    if (age && sAge && sAge !== age) return false;
    return true;
  });
  updateProductCards('healing-bath', 'Healing Bath', healingBathGroup, true);

  // Filter relaxing massage from addons
  const relaxingMassageGroup = addonsData.filter(addon => {
    const t = getProductType(addon);
    const speciesAddOn = (addon.SPECIES || '').trim().toLowerCase();
    const sizeAddOn = (addon.SIZE || '').trim();
    const speciesMatch = !speciesAddOn || speciesAddOn === normSpecies.toLowerCase();
    const sizeMatch = !sizeAddOn || !selectedSize || sizeAddOn === selectedSize;
    return t === 'relaxing massage' && speciesMatch && sizeMatch;
  });
  updateProductCards('relaxing-massage', 'Relaxing Massage', relaxingMassageGroup, true);

  // Filter addons general (excluding relaxing massage)
  const filteredAddons = addonsData.filter(addon => {
    const t = getProductType(addon);
    const speciesAddOn = (addon.SPECIES || '').trim().toLowerCase();
    const sizeAddOn = (addon.SIZE || '').trim();
    const speciesMatch = !speciesAddOn || speciesAddOn === normSpecies.toLowerCase();
    const sizeMatch = !sizeAddOn || !selectedSize || sizeAddOn === selectedSize;
    return t === "addons" && speciesMatch && sizeMatch;
  });

  // Combine: healing bath + relaxing massage + regular addons
  const allAddons = [
    ...healingBathGroup,
    ...relaxingMassageGroup,
    ...filteredAddons
  ];

  updateAddonsTable(allAddons);

  attachCardClickHandlers();
  updateSelectionSummary();
}

function initBreedDropdown() {
  const breedInput = document.getElementById('breedInput');
  const breedList = document.getElementById('breedList');
  if (!breedInput || !breedList) return;
  
  breedInput.addEventListener('input', function () {
    const val = this.value.toLowerCase();
    const filtered = breedsData.filter(b => (b.Breed || b.name).toLowerCase().includes(val));
    updateBreedList(filtered);
  });
  
  breedInput.addEventListener('focus', () => {
    updateBreedList(breedsData);
    breedList.style.display = 'block';
  });
  
  document.addEventListener('click', e => {
    if (!breedInput.contains(e.target) && !breedList.contains(e.target)) {
      breedList.style.display = 'none';
    }
  });
  
  function updateBreedList(items) {
    if (!breedList) return;
    if (!items.length) {
      breedList.innerHTML = "<div class='no-match'>No matching breeds found.</div>";
    } else {
      breedList.innerHTML = items.map(b =>
        `<div class='breed-list-item' data-breed="${b.Breed || b.name}" data-size="${b.Size || ''}" data-coat="${b.Coat || ''}">${b.Breed || b.name}</div>`
      ).join('');
      
      Array.from(breedList.children).forEach(child => {
        child.addEventListener('mousedown', function (e) {
          e.preventDefault();
          const breedInput = document.getElementById('breedInput');
          if (!breedInput) return;
          breedInput.value = this.getAttribute('data-breed');
          breedInput.dataset.size = this.getAttribute('data-size');
          breedInput.dataset.coat = this.getAttribute('data-coat');
          breedList.style.display = 'none';
        });
      });
    }
  }
}

function clearTables() {
  ["washing", "washing-hair-cutting", "washing-zero-trim", "healing-bath", "relaxing-massage", "addons"].forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.innerHTML = '';
      el.classList.remove('selected');
      delete el.dataset.id;
      delete el.dataset.price;
      delete el.dataset.duration;
      delete el.dataset.productType;
      el.style.display = 'none'; // Hide cards initially
    }
  });
  
  // Hide the section headers as well
  const sectionHeaders = document.querySelectorAll('.section-header');
  sectionHeaders.forEach(header => {
    header.style.display = 'none';
  });
  
  // Hide the card containers
  const plansContainer = document.querySelector('.plans-horizontal-cards');
  const extrasContainer = document.querySelector('.extras-horizontal-cards');
  
  if (plansContainer) plansContainer.style.display = 'none';
  if (extrasContainer) extrasContainer.style.display = 'none';
  
  selectedItems.clear();
  document.getElementById('selection-summary').style.display = 'none';
}

function initForm() {
  const form = document.getElementById('groomingForm');
  if (!form) return;
  
  const breedInput = document.getElementById('breedInput');
  const ageSelect = document.getElementById('ageSelect');
  const responseDiv = document.getElementById('responseMessage');
  
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const petType = getSelectedSpecies();
    const breed = breedInput.value.trim();
    const age = ageSelect.value;
    
    if (!breed) { 
      responseDiv.textContent = "Please enter your pet breed."; 
      return; 
    }
    if (!age) { 
      responseDiv.textContent = "Please select your pet's age."; 
      return; 
    }
    
    responseDiv.textContent = "";
    clearTables();
    
    const breedRec = findBreedRecord(breed);
    filterTables(breedRec, petType, age);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  Promise.all([fetchBreeds('dog'), fetchServices(), fetchAddons()]).then(() => {
    initBreedDropdown();
    initForm();
    
    document.querySelectorAll("input[name='petType']").forEach(radio => {
      radio.addEventListener('change', function () {
        fetchBreeds(this.value).then(() => {
          const breedInput = document.getElementById('breedInput');
          if (breedInput) {
            breedInput.value = '';
            breedInput.dataset.size = '';
            breedInput.dataset.coat = '';
          }
          clearTables();
        });
      });
    });
  });
});